/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".full-contractor-container[_ngcontent-%COMP%]{display:flex;flex:1 0 auto;flex-direction:column;align-items:center;justify-content:space-between;height:100%;background-color:#fafafa}.full-contractor-container[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]{background-color:#1a2e57;height:4.56rem;width:100%}@media only screen and (max-height:800px){.full-contractor-container[_ngcontent-%COMP%]   footer[_ngcontent-%COMP%]{height:2.28rem}}"];
export { styles as styles };
